// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__bz0NM","dragIcon":"Choice_dragIcon__6iWrG","left":"Choice_left__3KFk3","input":"Choice_input__2akYy"};